import React, { useRef, useState } from "react";
import { Button, Modal, Toast } from '@themesberg/react-bootstrap';
import { useCookies } from 'react-cookie';
import { register, createEmployeeWithGame, createEmployeeWithMultipleGames } from "../../../../../controller/api/employee";
import { AddNewEmployeeForm } from "./partials/AddNewEmployeeForm";

export default (props) => {
  const [cookies] = useCookies(['lottmekong']);
  const [error, setError] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const passwordRef = useRef('')
  const nameRef = useRef('')
  const phoneRef = useRef('')
  const identifyRef = useRef('')
  const gameIdsRef = useRef([])

  const onNameChange = (text) => {
    nameRef.current = text
  }

  const onPasswordChange = (text) => {
    passwordRef.current = text
  }

  const onPhoneChange = (text) => {
    phoneRef.current = text
  }

  const onIdentifyChange = (text) => {
    identifyRef.current = text
  }

  const onGamesChange = (gameIds) => {
    gameIdsRef.current = gameIds
  }

  const validate = () => {
    if (!nameRef.current || !passwordRef.current) {
      return false
    }
    if (passwordRef.current.length < 6) {
      return false
    }
    return true
  }

  const onSubmit = async () => {
    try {
      if (isSubmitting) {
        return
      }
      if (validate()) {
        setIsSubmitting(true)
        // Use new API that supports multiple games assignment
        const employeeData = {
          username: nameRef.current,
          password: passwordRef.current,
          phone: phoneRef.current ? phoneRef.current.trim() || null : null,
          identify: identifyRef.current ? identifyRef.current.trim() || null : null,
          gameIds: gameIdsRef.current || []
        }

        const resp = await createEmployeeWithMultipleGames(cookies.lottmekong, employeeData)
        if (resp && resp.status === 'success') {
          props.onHide()
          props.onSuccess && props.onSuccess()
        } else {
          setError(resp?.message || 'Có lỗi xảy ra')
        }
      } else {
        setError('Vui lòng nhập username và mật khẩu (tối thiểu 6 ký tự)')
      }
    } catch (e) {
      setError('Có lỗi xảy ra: ' + e.message)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Thêm nhân viên in vé
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Toast className="d-inline-block m-1" onClose={() => setError('')} show={!!error} delay={3000} autohide bg='danger' key={3} >
          <Toast.Header>
            <strong className="me-auto">Lỗi</strong>
            {/* <small>11 mins ago</small> */}
          </Toast.Header>
          <Toast.Body>{error || 'Không thêm được'}</Toast.Body>
        </Toast>
        <AddNewEmployeeForm
          setPassword={onPasswordChange}
          setName={onNameChange}
          setPhone={onPhoneChange}
          setIdentify={onIdentifyChange}
          setGames={onGamesChange}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={props.onHide}>Close</Button>
        <Button variant="primary" onClick={onSubmit} disabled={isSubmitting}>
          {isSubmitting ? 'Đang thêm...' : 'Thêm'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
